import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FaCalendarAlt , FaShoppingCart} from "react-icons/fa";
import { FaCreditCard } from "react-icons/fa";

const Header = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background-color: #ffffff;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
`;

const BottomNav = styled.div`
  background-color: white;
  padding: 1rem 0;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);

  transition: all 0.3s ease-in-out;
`;

const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (min-width: 1024px) {
    padding: 0 4rem;
  }
`;

const ContactInfo = styled.div`
  display: flex;
  gap: 1.5rem;
  color: #4a5568;

  div {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    img {
      width: 16px;
      height: 16px;
    }
  }
`;

const SocialIcons = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    gap: 1rem;

    a {
      font-size: 1.25rem;
      color: #3182ce;
      transition: color 0.3s ease;

      &:hover {
        color: #2c5282;
      }
    }
  }
`;
const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  .text-container {
    display: flex;
    flex-direction: column;

    a {
      text-decoration: none;
      font-size: 1.0rem; /* Default font size */
      font-weight: bold;
      color: #2d3748;
      transition: color 0.3s ease;
      white-space: normal; /* Allow text to wrap */
      overflow-wrap: break-word; /* Enable word wrapping */
      word-break: break-word; /* Break words for better wrapping */
      text-overflow: ellipsis; /* Add ellipsis if text overflows */

      &:hover {
        color:rgb(75, 117, 245); /* User's preferred red color */
      }
    }

    p {
      margin: 0.25rem 0 0; /* Minimal margin to bring the paragraph closer */
      font-size: 0.85rem;
      color: rgb(141, 4, 9);
      text-align: left;
      font-style: italic;
      display: none; /* Default hidden */

      @media (min-width: 768px) {
        display: block; /* Show on medium and larger screens */
        text-align: center;
        font-size: 0.9rem;
      }
    }

    /* For small screens, adjust the max width and ensure two-word wrapping */
    @media (max-width: 576px) {
      a {
        font-size: 1rem; /* Slightly smaller text */
        max-width: 10rem; /* Constrain width to encourage wrapping */
        text-align: left; /* Center align for better layout */
      }
    }
  }
`;

const Logo = styled.img`
  border-radius: 10%;
  width: 60px;
  height: 60px;
  object-fit: fit;
  background-color: rgba(255, 255, 255, 0.8);
  // box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  // border: 2px solid rgba(0, 0, 0, 0.15); /* Border for separation */
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
  }
`;

const NavWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: 768px) {
    align-items: center;
  }

  p {
    margin: 0.25rem 0 0; /* Minimal margin to bring the paragraph closer */
    font-size: 0.85rem;
    color: rgb(150, 5, 5);
    text-align: left;
    display: none; /* Default hidden */

    @media (min-width: 768px) {
      display: block; /* Show on medium and larger screens */
      text-align: center;
      font-size: 0.9rem;
    }
  }
`;

const NavLinks = styled.ul`
  display: none;
  margin-bottom: 0; /* Remove default bottom margin */

  @media (min-width: 768px) {
    display: flex;
    gap: 0.5rem;
    list-style: none;

    li {
      position: relative;

      a {
        text-decoration: none;
        color: #2d3748;
        font-weight: 700;
        transition: color 0.3s ease;

        &:hover {
          color: #3182ce;
        }

        &.active {
          color: #3182ce;
          font-weight: bold;
        }
      }
    }
  }
`;

const DropdownMenu = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 0.5rem 1rem;
  margin: 0;
  border-radius: 4px;
  display: ${({ show }) => (show ? "block" : "none")};

  li {
    padding: 0.5rem 0;

    a {
      text-decoration: none;
      color: #2d3748;

      &:hover {
        color: #3182ce;
      }
    }
  }
`;
const Button = styled.button`
  background: linear-gradient(
    90deg,
    rgb(87, 143, 255) 0%,
    rgb(67, 153, 239) 100%
  );
  color: #ffffff;
  font-weight: bold;
  font-size: 0.9rem;
  text-decoration: none; 
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  text-align: center;
  white-space: nowrap;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 12px rgba(0, 0, 0, 0.2);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  /* Remove underline from text */
  span {
    text-decoration: none; 
  }

  a {
    text-decoration: none; /* Ensures links inside button don't have underline */
    color: inherit;
  }

  @media (max-width: 576px) {
    font-size: 0.8rem;
    padding: 0.6rem;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    gap: 0;

    span {
      display: none;
    }

    svg {
      font-size: 1.2rem;
    }
  }
`;
const PaymentButton = styled(Button)`
  background: transparent;
  border: none;
  color:rgb(32, 33, 34); /* Keeps the red theme for text */
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 4px;
    box-shadow:none;
  // padding: 10px 15px;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.2s ease;

  &:hover {
    color:rgb(57, 138, 230);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const HamburgerMenu = styled.button`
  display: block;
  background: none;
  border: none;
  color: #4a5568;
  cursor: pointer;

  svg {
    width: 24px;
    height: 24px;
  }

  @media (min-width: 768px) {
    display: none;
  }
`;

const MobileMenu = styled.ul`
  position: absolute;
  top: 60px;
  right: 0;
  background: white;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  li a {
    text-decoration: none;
    color: #2d3748;

    &:hover {
      color: #3182ce;
    }
  }
`;

export default function NavBar() {
  const [showTopNav, setShowTopNav] = useState(true);
  const [showMenu, setShowMenu] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const currentPath = window.location.pathname;

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      setShowTopNav(window.scrollY <= lastScrollY);
      lastScrollY = window.scrollY;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => setShowMenu((prev) => !prev);
  const toggleDropdown = () => setShowDropdown((prev) => !prev);

  return (
    <Header>
      <BottomNav show={showTopNav}>
        <Container>
          <LogoContainer>
            <Logo src="/logos/logo3.png" alt="Pristine AC" />
            <div className="text-container">
              <a href="/">Pristine Academic Consultancy</a>
              <p>Education and Careers </p>
            </div>
          </LogoContainer>
          <NavWrapper>
            <NavLinks>
              <li>
                <a href="/" className={currentPath === "/" ? "active" : ""}>
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className={currentPath === "/about" ? "active" : ""}
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className={currentPath === "/services" ? "active" : ""}
                >
                  Services
                </a>
              </li>
              <li>
                <a
                  href="/events"
                  className={currentPath === "/events" ? "active" : ""}
                >
                  Events
                </a>
              </li>
              <li onMouseEnter={toggleDropdown} onMouseLeave={toggleDropdown}>
                <a
                  href="/resources"
                  className={currentPath === "resources" ? "active" : ""}
                >
                Resources
                </a>
                <DropdownMenu show={showDropdown}>
                  <li>
                    <a href="/blogs">Blogs</a>
                  </li>
                  <li>
                    <a href="articles">Articles</a>
                  </li>
                  <li>
                    <a href="/resources">Resources</a>
                  </li>
                </DropdownMenu>
              </li>
              <li>
                <a
                  href="/contact"
                  className={currentPath === "/contact" ? "active" : ""}
                >
                  Contact
                </a>
              </li>
            </NavLinks>
            <p>....Connecting your dots to success!</p>
          </NavWrapper>
          
          
          <PaymentButton as="a" href="/checkout">
          <FaCreditCard />
            
            <span>Make Payment</span>
          </PaymentButton>

          <Button as="a" href="/booking">
          <FaCalendarAlt />
            <span>Appointment</span>
          </Button>
          
          <HamburgerMenu
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </HamburgerMenu>
          {showMenu && (
            <MobileMenu>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About</a>
              </li>
              <li>
                <a href="/services">Services</a>
              </li>
              <li>
                <a href="/events">News and Events </a>
              </li>
              <li>
                <a href="/resources">Blogs & Resources</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
            </MobileMenu>
          )}
        </Container>
      </BottomNav>
    </Header>
  );
}
